module.exports = __webpack_public_path__ + "img/CIB+ Pfeil.03fd02dd.svg";